import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs';
import { Store } from '@ngrx/store';
import { checkAuthStatusSuccess } from '../shared/store/actions';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const store = inject(Store);

  return authService.isAuthenticated().pipe(
    map((auth) => {
      if (auth.authenticated) {
        store.dispatch(checkAuthStatusSuccess(auth));
        return true;
      }

      router.navigate(['/login']);
      return false;
    })
  );
};

export const authGuardChild: CanActivateChildFn = (route, state) => {
  const authService = inject(AuthService);
  const store = inject(Store);
  const router = inject(Router);

  return authService.isAuthenticated().pipe(
    map((auth) => {
      if (auth.authenticated) {
        store.dispatch(checkAuthStatusSuccess(auth));
        return true;
      }

      router.navigate(['/login']);
      return false;
    })
  );
};
